
import { apiRequest } from '../../apiCall'


export const getAllMusicOnHold = () => apiRequest('MusicOnHold.GetAllMusicOnHold')
export const getPurchaseInfoRequest = (id) => apiRequest('googleAnalyticsECommerce.getPurchaseInfo', {}, `?invoiceId=${id}`)
export const postGetAllCompany = (params) => apiRequest('SaleCompany.GetAllCompany', { ...params }, '', false, true)




